import React from "react";

const SitesId = ({ row }) => {
  return (
    <div>
      <div style={{ paddingBottom: "10px" }}>{row?.site?.id}</div>
    </div>
  );
};

export default SitesId;
